<script setup lang="ts">
import type {RcsCard, RcsCarousel, RcsPayload, RcsText} from "@/notification-template/interfaces";
import RCSText from "@/notification-template/components/rcs/RCSText.vue";
import RCSCard from "@/notification-template/components/rcs/RCSCard.vue";
import RCSCarousel from "@/notification-template/components/rcs/RCSCarousel.vue";
import {ConversationMessageInteraction} from "@/conversation/interfaces";
import MessageInteractions from "@/conversation/components/MessageInteractions.vue";

defineProps<{
    payload: RcsPayload;
    interactions?: ConversationMessageInteraction[];
}>();

const isText = (payload: RcsPayload): payload is RcsText => payload.type === 'text';
const isCard = (payload: RcsPayload): payload is RcsCard => payload.type === 'card';
const isCarousel = (payload: RcsPayload): payload is RcsCarousel => payload.type === 'carousel';
</script>

<template>
  <div class="max-w-xs">
    <RCSText v-if="isText(payload)" :payload="payload" class="border border-muted" />
    <RCSCard v-else-if="isCard(payload)" :payload="payload" />
    <RCSCarousel v-else-if="isCarousel(payload)" :payload="payload" />
    <MessageInteractions
      v-if="interactions?.length"
      class="mt-1.5"
      :interactions="interactions"
      :payload="payload"
    />
  </div>
</template>
